// Every date and time the portal shows, and every time it asks for, is Pakistan
// Standard Time, whatever zone the admin's computer is set to. Pakistan has no
// daylight saving, so the offset is a constant +05:00.
export const TIME_ZONE = "Asia/Karachi";
const OFFSET = "+05:00";

const valid = (iso: string | null | undefined): Date | null => {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** 15 Oct 2026 */
export function formatDate(iso: string | null | undefined): string {
  const date = valid(iso);
  return date
    ? date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: TIME_ZONE,
      })
    : "";
}

/** 3:05 pm */
export function formatTime(iso: string | null | undefined): string {
  const date = valid(iso);
  return date
    ? date.toLocaleTimeString("en-GB", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: TIME_ZONE,
      })
    : "";
}

/** 15 Oct 2026, 03:05 pm PKT */
export function formatDateTime(iso: string | null | undefined): string {
  const date = valid(iso);
  return date
    ? `${date.toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: TIME_ZONE,
      })} PKT`
    : "";
}

/** The Pakistan calendar date, YYYY-MM-DD. */
export function pkDayKey(date: Date): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

// <input type="datetime-local"> holds "YYYY-MM-DDTHH:mm" with no zone. Here that
// is always Pakistan time: the API speaks offset-aware ISO, so convert both
// ways instead of slicing the string or trusting the browser's zone.
export function toPkInput(iso: string | null | undefined): string {
  const date = valid(iso);
  if (!date) return "";
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-CA", {
      timeZone: TIME_ZONE,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    })
      .formatToParts(date)
      .map((part) => [part.type, part.value])
  );
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function fromPkInput(value: string): string {
  return new Date(`${value}:00${OFFSET}`).toISOString();
}
